// extracted by mini-css-extract-plugin
module.exports = {"errorPageHeaderTokens":"errorPageHeader_errorPageHeaderTokens__NHvbD","errorPageHeader":"errorPageHeader_errorPageHeader__o2yfd","fullscreen":"errorPageHeader_fullscreen__1Hcn6"};